module.exports = "https://qp-assets.quero.com/assets/images/landing/blue-line.svg?07d5e732220dfb498ef2eb387620f4ce";